var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3E236E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 4.66667C7.29284 4.66667 6.61456 4.94762 6.11446 5.44772C5.61437 5.94781 5.33341 6.62609 5.33341 7.33333C5.33341 8.36602 6.00533 9.36808 6.74207 10.1458C7.10362 10.5274 7.4663 10.8398 7.73897 11.0569C7.84045 11.1378 7.92909 11.2051 8.00008 11.2575C8.07107 11.2051 8.15971 11.1378 8.26119 11.0569C8.53386 10.8398 8.89654 10.5274 9.2581 10.1458C9.99484 9.36808 10.6667 8.36602 10.6667 7.33333C10.6667 6.62609 10.3858 5.94781 9.8857 5.44772C9.3856 4.94762 8.70733 4.66667 8.00008 4.66667ZM8.00008 11.6667C7.81518 11.944 7.8151 11.944 7.815 11.9439L7.81405 11.9433L7.81183 11.9418L7.80419 11.9366C7.7977 11.9322 7.78844 11.9259 7.7766 11.9177C7.75292 11.9013 7.7189 11.8774 7.67601 11.8464C7.59026 11.7845 7.46887 11.6941 7.32369 11.5785C7.03386 11.3477 6.64654 11.0143 6.2581 10.6042C5.49484 9.79858 4.66675 8.63398 4.66675 7.33333C4.66675 6.44928 5.01794 5.60143 5.64306 4.97631C6.26818 4.35119 7.11603 4 8.00008 4C8.88414 4 9.73198 4.35119 10.3571 4.97631C10.9822 5.60143 11.3334 6.44928 11.3334 7.33333C11.3334 8.63398 10.5053 9.79858 9.74207 10.6042C9.35362 11.0143 8.9663 11.3477 8.67647 11.5785C8.53129 11.6941 8.4099 11.7845 8.32415 11.8464C8.28126 11.8774 8.24724 11.9013 8.22356 11.9177C8.21172 11.9259 8.20247 11.9322 8.19598 11.9366L8.18834 11.9418L8.18611 11.9433L8.18541 11.9437C8.18531 11.9438 8.18498 11.944 8.00008 11.6667ZM8.00008 11.6667L8.18498 11.944C8.07301 12.0187 7.92697 12.0185 7.815 11.9439L8.00008 11.6667Z",
    fill: "#F7F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 6.66667C7.63189 6.66667 7.33341 6.96514 7.33341 7.33333C7.33341 7.70152 7.63189 8 8.00008 8C8.36827 8 8.66675 7.70152 8.66675 7.33333C8.66675 6.96514 8.36827 6.66667 8.00008 6.66667ZM6.66675 7.33333C6.66675 6.59695 7.2637 6 8.00008 6C8.73646 6 9.33341 6.59695 9.33341 7.33333C9.33341 8.06971 8.73646 8.66667 8.00008 8.66667C7.2637 8.66667 6.66675 8.06971 6.66675 7.33333Z",
    fill: "#F7F8FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.143791824cc446ba4ea8f3530092abaa.svg";
export { ForwardRef as ReactComponent };